export const ResendingTimer: number = 1500;
export const ComPortScannerUrl: string = "http://localhost:3320/F3TailHub";
export const informationUrl: string = "http://10.93.1.47:13001";
export const treeViewFolderSupplier: Readonly<ITreeViewFolder> = { folderId: "ba5f95c2-0c80-4800-8d8f-b75b4b27f456", displayName: "Поставщики", childGroups: 0 };
export const treeViewFolderPharmacy: Readonly<ITreeViewFolder> = { folderId: "8692927b-ea2a-4649-b43c-4666ec1bb46e", displayName: "Аптеки", childGroups: 0 };
export const treeViewFolderBuyer: Readonly<ITreeViewFolder> = { folderId: "3e1b993b-7f5c-494a-8e94-d863c6e40e57", displayName: "Покупатели", childGroups: 0 };
export const treeViewFolderEmpty: Readonly<ITreeViewFolder> = { folderId: '', displayName: "", childGroups: 0 };

//Global Alert
export const DURATION_MSEC_ALERT = 10000 // время отображения всплывающего сообщения
export const DURATION_MSEC_MODAL_ALERT = 100000 // время отображения модального окна с сообщением
export const MAX_ALERTS_COUNT = 2 // количество отображаемых всплывающих сообщений
export const MAX_ALERTS_HISTORY_COUNT = 100 // количество хранимых сообщений в истории
export const MAX_ALERTS_SHOW_BUTTON_CLOSE_ALL = 2 // количество отображаемых всплывающих сообщения для отображения кнопки "Закрыть все"

// Чат с новостями newsChat
export const POLLING_INTERVAL_ACTIVE = 30000;    // 30 сек когда окно открыто
export const POLLING_INTERVAL_BACKGROUND = 600000; // 10 мин когда окно закрыто
export const POLLING_INTERVAL_NIGHT = 3600000;     //  1 час в ночное время
export const MARK_AS_VIEWED_DELAY = 3000; // 3 секунды до отметки о прочтении
export const MAX_NEWS_HISTORY_COUNT = 30

//InfoCarousel
export const INFO_CAROUSEL_INITIAL_DELAY = 5000; // 5 секунд - задержка перед первым опросом при рендере
export const INFO_CAROUSEL_POLLING_INTERVAL = 10800000; // 3 часа (10800000 мс) - интервал опроса сервера
export const INFO_CAROUSEL_AUTOPLAY_SPEED = 60000; // интервал смены баннеров